// extracted by mini-css-extract-plugin
export var centerText = "_7i-8";
export var container = "_7i-0";
export var doughnutContainer = "_7i-7";
export var legend = "_7i-a";
export var legendItemColorDisplay = "_7i-b";
export var legendItemLabel = "_7i-d";
export var legendItemValue = "_7i-c";
export var lg = "_7i-5";
export var maxWidth = "_7i-9";
export var md = "_7i-4";
export var responsive = "_7i-6";
export var sm = "_7i-3";
export var xs = "_7i-2";
export var xxs = "_7i-1";